// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__16skS","error":"Textarea_error__2l7M5","readonly":"Textarea_readonly__3cXCg","disabled":"Textarea_disabled__23jX0"};